import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import MenuCategory from "./MenuCategory";
import AppContext from "../contexts/appContext";

export default function ServiceMenu() {
  const { menu } = useContext(AppContext);

  const [showServices, setShowServices] = useState([]);
  const [showService, setShowService] = useState(-1);

  const toggleService = (serviceId) => {
    let updatedShowServices = [...showServices];
    const serviceIdx = updatedShowServices.indexOf(serviceId);
    if (serviceIdx > -1) {
      updatedShowServices.splice(serviceIdx, 1);
    } else {
      updatedShowServices.push(serviceId);
    }
    setShowServices(updatedShowServices);
  };

  const toggleSingleService = (serviceId) => {
    setShowService(serviceId);
  };

  return (
    <nav className="z-20 bg-white lg:bg-transparent drop-shadow-xl rounded-xl p-5 lg:p-0">
      <ul className="flex flex-col lg:flex-row font-semibold">
        {menu?.length > 0
          ? menu?.map((service, index) => (
              <li
                key={`menu-${service.name}-${service.id}`}
                className="dropdown inline-block relative"
              >
                <div
                  //   to={`/buy-${service.name.toLowerCase()}-services/${service.id}`}
                  onMouseEnter={() => toggleSingleService(service.id)}
                  onMouseLeave={() => toggleSingleService(service.id)}
                  className="hidden lg:inline-flex py-2 px-2 font-semibold whitespace-no-wrap hover:text-pink-350 transition-all cursor-pointer"
                >
                  <span>{service.name} &#x23f7;</span>
                </div>
                {showService === service.id ? (
                  <ul className="dropdown-content lg:absolute lg:hidden bg-white pt-1 uppercase font-semibold w-36">
                    {service?.category.map((category) => {
                      return (
                        <MenuCategory
                          key={`service-category-${category.name}-${category.id}`}
                          categoryKey={`${service.name}-category-${category.name}`}
                          categoryLink={`/buy-${service.name.toLowerCase()}-${category.name.toLowerCase()}/${
                            service.id
                          }/${category.id}/${category.subcategory[0]?.id}`}
                          categoryName={category?.name}
                          fragmentKey={`${service.name}-category-${category.name}-subcategory`}
                          map={category?.subcategory}
                          category={category}
                          linkTo={`/buy-${service.name.toLowerCase()}-${category.subcategory[0].name.toLowerCase()}/${
                            service.id
                          }/${category.id}`}
                          itemLinkTo={`/getstarted/${service.name.toLowerCase()}/${service.id}/${
                            category.id
                          }`}
                          side={index > 2 ? "left" : "right"}
                        />
                      );
                    })}
                  </ul>
                ) : null}
                <button
                  onClick={() => toggleService(service.id)}
                  className="inline-flex lg:hidden py-2 px-2 font-semibold items-center uppercase"
                >
                  {service.name}{" "}
                  {showServices.indexOf(service.id) > -1 ? <>&#x23f7;</> : <>&#x23f5;</>}
                </button>
                {showServices.indexOf(service.id) > -1 ? (
                  <ul className="dropdown-content lg:absolute lg:hidden bg-white pt-1 uppercase font-semibold w-40">
                    {service?.category.map((category) => {
                      return (
                        <MenuCategory
                          key={`service-category-${category.name}-${category.id}`}
                          categoryKey={`${service.name}-category-${category.name}`}
                          categoryLink={`/buy-${service.name.toLowerCase()}-${category.name.toLowerCase()}/${
                            service.id
                          }/${category.id}/${category.subcategory[0]?.id}`}
                          categoryName={category?.name}
                          fragmentKey={`${service.name}-category-${category.name}-subcategory`}
                          map={category?.subcategory}
                          category={category}
                          linkTo={`/buy-${service.name.toLowerCase()}-${category.subcategory[0].name.toLowerCase()}/${
                            service.id
                          }/${category.id}`}
                          itemLinkTo={`/getstarted/${service.name.toLowerCase()}/${service.id}/${
                            category.id
                          }`}
                        />
                      );
                    })}
                  </ul>
                ) : null}
              </li>
            ))
          : null}
      </ul>
    </nav>
  );
}
